import PropTypes from "prop-types"
import React, { useEffect } from "react"
import styled from "styled-components"

import { Box } from "components/common"

const cdn_asset_path = (path, dev_server = null) =>
  `${dev_server ? dev_server : "https://assets.jewlr.com/"}${path}`

const localizeHype = () => {
  const hypeTexts = document.getElementsByClassName("text_all")
  Array.from(hypeTexts).forEach((hypeText) => {
    if (!hypeText.classList.contains(`text_${sl.config.site_country}`)) {
      hypeText.style.display = "none"
    }
  })
}

let hypeLoaded = {}
const loadHype = (hype_container_name, hype_project_name) => {
  if (typeof document !== "undefined" && !hypeLoaded[hype_project_name]) {
    var dh = document.createElement("script")
    dh.type = "text/javascript"
    dh.id = hype_project_name
    dh.src = cdn_asset_path(
      `hype/${hype_project_name}/${hype_project_name}.hyperesources/${hype_container_name}_hype_generated_script.js`
    )
    var s = document.getElementsByTagName("script")[0]
    s.parentNode.insertBefore(dh, s)
    hypeLoaded[hype_project_name] = true
    if (typeof window.HYPE_eventListeners === "undefined") {
      window.HYPE_eventListeners = [
        {
          callback: localizeHype,
          type: "HypeSceneLoad",
        },
      ]
    }
  }
}

const CollectionBannerWrapper = styled.div`
  box-sizing: content-box;
  position: relative;
  ${(props) => props.theme.mediaQueries.desktop`
    margin-top: 0;
  `}
  ${(props) =>
    props.type == "main" &&
    `
    overflow: hidden;
  `}
  ${(props) =>
    props.type == "collection" &&
    `
    margin-left: auto;
    margin-right: auto;
    ${props.theme.mediaQueries.tablet`
      max-width: 45.9375em;
    `}
    ${props.theme.mediaQueries.desktop`
      max-width: 59.6875em;
    `}
    ${props.theme.mediaQueries.widescreen`
      max-width: 63.75em;
    `}
  `}
  ${(props) =>
    props.type == "jlux" &&
    `
    ${props.theme.mediaQueries.tablet`
      height: 180px !important;
      ${props.theme.mediaQueries.desktop`
        margin-bottom: 48px;
      `}
    `}
  `}
`

const InnerCollectionBannerWrapper = styled.div`
  min-height: 34px;
  ${(props) => props.theme.mediaQueries.desktop`
    min-height: 0;
  `}
`

const HypeScaledElement = styled.img`
  width: 100%;
`

const HypeScaledImage = styled.img`
  width: 100%;
  ${(props) => props.theme.mediaQueries.desktop`
    width: auto;
    position: relative;
    left: 50%;
    transform: translateX(-50%) translateY(0);
  `}
`

const HypeElement = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`

const CollectionWrapper = styled(Box).attrs({
  display: { _: "none", tablet: "block" },
})`
  position: relative;
  overflow: hidden;
  width: ${(props) => `${props.hype_width}px`};
  height: ${(props) => `${props.hype_height}px`};
`

// TODO: Handle lazy_loading
const HypeBanner = ({ dev_server = null, hype_project_name }) => {
  let hype_container_name = hype_project_name.replace(/_/g, "")
  let hype_width = 1920
  let hype_height = 300
  if (hype_project_name.substring(0, 5) == "20151") {
    hype_width = 1024
    hype_height = 160
  } else if (hype_project_name.substring(0, 4) >= "2016") {
    hype_width = null
    hype_height = null
  }

  useEffect(() => {
    loadHype(hype_container_name, hype_project_name)
    return () => {
      document.getElementById(hype_project_name).remove()
      hypeLoaded[hype_project_name] = false
    }
  }, [])

  let preload = ""
  if (hype_project_name.substring(0, 8) >= "20170927") {
    if (
      hype_project_name.includes("extended") ||
      hype_project_name.includes("fullsize")
    ) {
      preload = (
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet={cdn_asset_path(
              `hype/${hype_project_name}/${hype_project_name}.hyperesources/mobile.jpg`,
              dev_server
            )}
          />
          <source
            media="(min-width: 768px) and (max-width: 1023px)"
            srcSet={`${cdn_asset_path(
              `hype/${hype_project_name}/${hype_project_name}.hyperesources/tablet.jpg`,
              dev_server
            )} 1x, ${cdn_asset_path(
              `hype/${hype_project_name}/${hype_project_name}.hyperesources/tablet_2x.jpg`,
              dev_server
            )} 2x`}
          />
          <source
            media="(min-width: 1024px)"
            srcSet={`${cdn_asset_path(
              `hype/${hype_project_name}/${hype_project_name}.hyperesources/desktop.jpg`,
              dev_server
            )} 1x, ${cdn_asset_path(
              `hype/${hype_project_name}/${hype_project_name}.hyperesources/desktop_2x.jpg`,
              dev_server
            )} 2x`}
          />
          <HypeScaledImage
            srcSet={cdn_asset_path(
              `hype/${hype_project_name}/${hype_project_name}.hyperesources/desktop_2x.jpg`,
              dev_server
            )}
          />
        </picture>
      )
    } else {
      preload = (
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet={cdn_asset_path(
              `hype/${hype_project_name}/${hype_project_name}.hyperesources/mobile.jpg`,
              dev_server
            )}
          />
          <source
            media="(min-width: 768px)"
            srcSet={`${cdn_asset_path(
              `hype/${hype_project_name}/${hype_project_name}.hyperesources/desktop.jpg`,
              dev_server
            )} 1x, ${cdn_asset_path(
              `hype/${hype_project_name}/${hype_project_name}.hyperesources/desktop_2x.jpg`,
              dev_server
            )} 2x`}
          />
          <HypeScaledElement
            srcSet={cdn_asset_path(
              `hype/${hype_project_name}/${hype_project_name}.hyperesources/desktop_2x.jpg`,
              dev_server
            )}
          />
        </picture>
      )
    }
  } else if (
    hype_project_name.substring(0, 4) >= "2016" &&
    !hype_project_name.includes("extended") &&
    !hype_project_name.includes("fullsize") &&
    !hype_project_name.includes("_landing")
  ) {
    preload = (
      <picture>
        <source
          media="(max-width: 1023px)"
          srcSet={`${sl.config.jewlr_asset_url}images/homepage/jewlr/main_banner/collection-banner-mobile_size-ratio.jpg`}
        />
        <source
          media="(min-width: 1024px)"
          srcSet={`${sl.config.jewlr_asset_url}images/homepage/jewlr/main_banner/collection-banner-desktop_size-ratio.jpg`}
        />
        <HypeScaledElement
          srcSet={`${sl.config.jewlr_asset_url}images/homepage/jewlr/main_banner/collection-banner-desktop_size-ratio.jpg`}
        />
      </picture>
    )
  }

  let hypeElement = ""
  if (hype_project_name.substring(0, 8) >= "20170927") {
    hypeElement = <HypeElement id={`${hype_container_name}_hype_container`} />
  } else if (hype_width && hype_height) {
    hypeElement = (
      <InnerCollectionBannerWrapper>
        <CollectionWrapper
          hype_height={hype_height}
          hype_width={hype_width}
          id={`${hype_container_name}_hype_container`}
        />
      </InnerCollectionBannerWrapper>
    )
  } else if (
    (!hype_width || !hype_height) &&
    !hype_project_name.includes("extended") &&
    !hype_project_name.includes("fullsize")
  ) {
    hypeElement = <HypeElement id={`${hype_container_name}_hype_container`} />
  } else {
    hypeElement = <HypeElement id={`${hype_container_name}_hype_container`} />
  }

  let bannerType = "container"
  if (
    (hype_project_name.substring(0, 5) == "20151" ||
      hype_project_name.substring(0, 4) >= "2016") &&
    (hype_project_name.includes("extended") ||
      hype_project_name.includes("fullsize"))
  ) {
    bannerType = "main"
  }
  if (hype_project_name.includes("20170927_jlux")) {
    bannerType = "jlux"
  }

  return (
    <CollectionBannerWrapper style={{ width: "100%" }} type={bannerType}>
      {preload}
      {hypeElement}
    </CollectionBannerWrapper>
  )
}

HypeBanner.propTypes = {
  dev_server: PropTypes.object,
  hype_project_name: PropTypes.string,
}

export default HypeBanner
